import { priceFormat } from "@/utils/common";
import AgreementRow from "../agreement-row";
import "./index.less";
import { useRef } from "react";
import RedPackPopup from "../red-pack-popup";
import { useGoodsFocus } from "../tab-goods-content/GoodsFocusContext";
import { useUserContext } from "../../routes/home/userContext";

const BuyGoodContent = ({ doBuyMemberGoods }) => {
  const RedPackRef = useRef<any>(null);
  const { focusedGoods } = useGoodsFocus();
  const { balanceCredit, levelInfo } = useUserContext();
  if (!focusedGoods || Object.keys(focusedGoods)?.length === 0) return null;

  const isCarOwner = levelInfo?.memberType === 1;

  const showCredit =
    isCarOwner || (!isCarOwner && balanceCredit && balanceCredit > 0);

  const isDiscount =
    focusedGoods?.discountType !== "ORIGINAL_PRICE" &&
    focusedGoods?.salePrice !== focusedGoods?.discountBuyPrice;
  const clickBuyBtn = () => {
    doBuyMemberGoods(focusedGoods);
  };

  // 金额整数部分
  const priceInt =
    String(
      priceFormat(
        isDiscount ? focusedGoods?.discountBuyPrice : focusedGoods?.salePrice,
      ),
    )?.split(".")?.[0] || "";
  // 金额小数部分
  const priceDec =
    String(
      priceFormat(
        isDiscount ? focusedGoods?.discountBuyPrice : focusedGoods?.salePrice,
      ),
    )?.split(".")?.[1] || "";

  const buyText = () => {
    const textEnums = {
      SECONDS_KILL_PRICE: "立即秒杀",
      ORIGINAL_PRICE: "立即购买",
      COUPON_PRICE: "优惠购买",
    };
    return textEnums[focusedGoods?.discountType] || "立即购买";
  };

  const limitNum = focusedGoods?.limitNum;

  return (
    <div className="buy-good-content with-corner">
      {focusedGoods?.discountType === "COUPON_PRICE" && (
        <div className="corner" onClick={() => RedPackRef.current?.onShow()}>
          红包已减
          {priceFormat(
            focusedGoods?.salePrice - focusedGoods?.discountBuyPrice,
          )}
          元{" >"}
        </div>
      )}
      {focusedGoods?.discountType !== "SECONDS_KILL_PRICE" ? (
        <div className="buy-btn" onClick={clickBuyBtn}>
          <div className="buy-text-container">
            {buyText()}
            {!!priceInt && <div className="buy-text-unit">¥</div>}
            <div className="final-price-big">{priceInt}</div>
            <div className="final-price-small">
              {priceDec && `.${priceDec}`}
            </div>
            {!!focusedGoods?.maxUseCreditAmount && !!showCredit && (
              <div className="sale-price">
                （积分价：{focusedGoods?.maxUseCreditAmount}积分）
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="buy-btn seckill" onClick={clickBuyBtn}>
          <div className="buy-text-container seckill">
            <div className="buy-text-unit">¥</div>
            <div className="final-price-big">
              {priceInt}{priceDec && `.${priceDec}`}
            </div>
            {!!focusedGoods?.maxUseCreditAmount && !!showCredit ? (
              <div className="price-type">
                积分价： {focusedGoods?.maxUseCreditAmount}积分
              </div>
            ) : focusedGoods?.discountType === "SECONDS_KILL_PRICE" ? (
              <div className="price-type">秒杀价</div>
            ) : (
              <></>
            )}
          </div>
          <div className="seckill-info">
            <div className="seckill-text">马上抢</div>
            {limitNum && limitNum < 999 ? (
              <div className="seckill-num">限购{limitNum}份</div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}

      <RedPackPopup ref={RedPackRef} />

      <AgreementRow />
    </div>
  );
};
export default BuyGoodContent;
